export default __webpack_public_path__ + "static/media/EM0750.34I-23429_-15264_0.6862931b.jpg";